import BaseService from './base-service';

const GET_CONFIGS_URL = '/api/v1/events/{{eid}}/integration-configs';
const CONGRESS_API_DEFAULT_CONFIG_DOC_ID = 'congress_api_default_config';

/**
 * Provides a facility to monitor the status of a specific running job.
 *
 * @example
 * import IntegrationsService from 'libs/services/integrations';
 * ...
 * const integrations = new IntegrationsService();
 */
export default class IntegrationsService extends BaseService {
    /**
     * Returns fields for all available integrations
     *
     * @param {String} eid
     * @returns {Promise<{{_id:string;name:string;fields:string[];searchable:string[]}[]}>}
     */
    async getIntegrationConfigs(eid) {
        const url = this.buildUrl(GET_CONFIGS_URL, { eid });
        const { data } = await this.get(url);
        return data;
    }

    /**
     * Fetches the Congress API default configuration document.
     *
     * @param {string} eventId
     * @returns {Promise<any>}
     */
    async getCongressApiDefaultConfig(eventId) {
        try {
            return await this._services.documents.getDocById(eventId, CONGRESS_API_DEFAULT_CONFIG_DOC_ID, true);
        } catch (err) {
            console.error('[IntegrationsService] could not load congress api default config', err);
            return {};
        }
    }

    /**
     * Returns the list of API fields that can be mapped.
     *
     * @param {string} eventId
     * @returns {Promise<string[]>}
     */
    async getCongressApiReturnedKeysForMapping(eventId) {
        const config = await this.getCongressApiDefaultConfig(eventId);
        return config?.returned_keys || [];
    }
}
